'use client';

import { partners } from '@/constants';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import Carousel from '../ui/Carousel';
import H6 from '../ui/H6';
import Section from './Section';

export default function PartnersSection() {
    const t = useTranslations();
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [isTransitioning, setIsTransitioning] = useState<boolean>(false);

    useEffect(() => {
        setIsTransitioning(true);

        const timer = setTimeout(() => {
            setIsTransitioning(false);
        }, 500);

        return () => clearTimeout(timer);
    }, [activeIndex]);

    return (
        <Section
            id="partners"
            title={t('Header.partners')}
            className="relative max-xl:min-h-0 overflow-hidden lg:py-0"
        >
            <div className="max-lg:min-h-[550px] lg:w-5/6 w-full ml-auto max-lg:ml-5 gap-10 pt-[100px] lg:pt-[260px]">
                <Carousel
                    slides={partners(t)}
                    mode="partners"
                    autoplay
                    infinite
                    onActiveIndexChange={(index) => setActiveIndex(index)}
                />
                <div className="flex flex-col gap-1 lg:gap-2 lg:mt-[160px] mt-[74px] pt-7 lg:pt-[60px] border-t border-gray-200 lg:h-[300px] h-[100px]">
                    <H6
                        className={`lg:mb-2 mb-1 transition-all duration-500 ${
                            isTransitioning ? 'opacity-0' : 'opacity-100'
                        }`}
                    >
                        {partners(t)[activeIndex].title}
                    </H6>
                    {partners(t)[activeIndex].texts.map((text, idx) => (
                        <span
                            key={idx}
                            className={`uppercase max-lg:text-h6 lg:text-[28px] font-normal text-black/50 transition-all pr-5 ${
                                isTransitioning ? 'opacity-0' : 'opacity-100'
                            }`}
                        >
                            {text}
                        </span>
                    ))}
                </div>
            </div>
        </Section>
    );
}
